/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewheldtitle3Inputs */

const en_sharereviewheldtitle3 = /** @type {(inputs: Sharereviewheldtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Held`)
};

const de_sharereviewheldtitle3 = /** @type {(inputs: Sharereviewheldtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurückgehalten`)
};

/**
* | output |
* | --- |
* | "Held" |
*
* @param {Sharereviewheldtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewheldtitle3 = /** @type {((inputs?: Sharereviewheldtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewheldtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewheldtitle3(inputs)
	return de_sharereviewheldtitle3(inputs)
});
export { sharereviewheldtitle3 as "shareReviewHeldTitle" }